<template>
  <div id="the-head">
    <TheBreadcrumb class="the-breadcrumb" />
    <div class="systemSelectContainer" v-if="showGlobalPlatformSelecter && type === '0'">
      当前平台：<el-select v-model="selectedSystem" placeholder="请选择系统" @change="platformSelectChange">
        <el-option
          v-for="item in platformData"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="head-right">
      <img :src="require('../assets/static/img/layout/user.png')" class="user-icon">
      <TheDropdown class="the-dropdown" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TheDropdown from '@/components/TheDropdown'
import TheBreadcrumb from '@/components/TheBreadcrumb'

export default {
  name: 'TheHead',
  data () {
    return {
      platformData: [],
    }
  },
  components: {
    TheDropdown,
    TheBreadcrumb,
  },
  computed: {
    ...mapState([
      'type',
      'username',
      'loginPlatform',
      'selectedSystem',
      'showGlobalPlatformSelecter',
    ]),
    selectedSystem: {
      get () {
        return this.$store.state.selectedSystem
      },
      set (newVal) {
        this.setSystemSelect(newVal)
      },
    },
  },
  methods: {
    ...mapMutations([
      'setSystemSelect',
    ]),
    /**
     * @description             平台选择change事件
     * @param {String}       当前选择值
     * @return {undefined}      无返回值
     */
    platformSelectChange (e) {
      localStorage.setItem('platformId', e)
    },
    /**
     * @description             获取平台树形数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    getPlatformTree () {
      this.$http.get('/api/platform/all')
        .then(res => {
          if (res.code === 'success') {
            if (res.data.list.length) {
              this.platformData = res.data.list
              if (this.loginPlatform.id && this.loginPlatform.id !== 0) {
                this.setSystemSelect(this.loginPlatform.id)
              } else {
                this.setSystemSelect(res.data.list[0].id)
              }
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getPlatformTree()
  },
}
</script>

<style lang="less" scoped>
#the-head {
  height: 55px;
  padding-left: 18px;
  padding-right: 32px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;

  .the-breadcrumb {
    display: inline-block;
    height: 55px;
    overflow: hidden;
    line-height: 55px;

    /deep/ .el-breadcrumb__inner {
      color: #666;
      font-weight: normal;
    }
  }

  .systemSelectContainer {
    height: 100%;
    line-height: 56px;
  }

  .head-right {
    .user-icon {
      width: 30px;
      height: 30px;
      margin-right: 14px;
      vertical-align: 12px;
    }

    .the-dropdown {
      height: 55px;
      overflow: hidden;
      line-height: 55px;

      /deep/ .el-breadcrumb__inner {
        color: #666;
        font-weight: normal;
      }
    }
  }
}
</style>
